module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><g><path d=\"M0 0h24v15h-24z\"/><path d=\"M13 17h11v7h-11z\"/><path d=\"M0 17h11v7h-11z\"/></g></svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/minimized.svg
// module id = 810
// module chunks = 1